import axios from "axios";
import {
    AUTH_SET_TOKEN,
    AUTH_LOGOUT
} from "src/modules/auth/actions/authentication.action";
import api from "./api";

const interceptors = (store, history) => {
    /**
     * Set authorization header to api
     * requests
     */
    store.subscribe(() => {
        const {
            authentication: { authToken }
        } = store.getState();
        if (authToken && authToken.token) {
            const { token } = authToken;
            localStorage.setItem("token", token);
            Object.assign(api.defaults, {
                headers: { authorization: `Bearer ${token}` }
            });
        }
    });

    /**
     * Refresh token if it was invalidated
     * Or logout if the status code is 403
     */
    api.interceptors.response.use(
        response => response.data,
        error => {
            const originalRequest = error.config;
            if (error.response && error.response.status) {
                /*
                 * Logout user if the status code is 403
                 */

                if (error.response.status === 401 && !originalRequest._retry) {
                    const {
                        authentication: { authToken, authUser }
                    } = store.getState();
                    if (authToken) {
                        const { refreshToken } = authToken;
                        originalRequest._retry = true;

                        return axios
                            .post(`${process.env.API_URL}/auth/update`, {
                                refreshToken,
                                isOperator: authUser.isOperator
                            })
                            .then(res => {
                                const {
                                    data: { data }
                                } = res;
                                Object.assign(originalRequest, {
                                    headers: {
                                        authorization: `Bearer ${data.token}`
                                    }
                                });
                                store.dispatch({
                                    type: AUTH_SET_TOKEN,
                                    payload: data
                                });
                                if (originalRequest.data) {
                                    originalRequest.data = JSON.parse(
                                        originalRequest.data
                                    );
                                }
                                return api.request(originalRequest);
                            })
                            .catch(error => {
                                if (
                                    error.response &&
                                    error.response.status &&
                                    error.response.status === 403
                                ) {
                                    store.dispatch({
                                        type: AUTH_LOGOUT,
                                        payload: {}
                                    });
                                    localStorage.clear();
                                    history.push("/auth/login");
                                } else if (
                                    error.response &&
                                    error.response.status &&
                                    error.response.status === 401
                                ) {
                                    store.dispatch({
                                        type: AUTH_LOGOUT,
                                        payload: {}
                                    });
                                } else {
                                    throw error;
                                }
                            });
                    }

                    store.dispatch({ type: AUTH_LOGOUT, payload: {} });
                }
            }
            return Promise.reject(error);
        }
    );
};
export default interceptors;
